module.exports = __webpack_public_path__ + "static/tomie-balogun-4f3addaa2258c98976ab82e64e2e9fd8.png";